const base64ToArrayBuffer = (base64: string): Uint8Array => {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);

  for (let i = 0; i < binaryLen; i += 1) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }

  return bytes;
};

const openPdfFromBase64 = (base64: string): void => {
  const arrayBuffer = base64ToArrayBuffer(base64);
  const file = new Blob([arrayBuffer], { type: 'application/pdf' });
  const fileURL = URL.createObjectURL(file);

  window.open(fileURL);
};

const openFile = (file: File): void => {
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL);
};

const downloadPdfFromBase64 = (base64: string, filename: string): void => {
  const a = document.createElement('a');
  const linkSource = `data:application/pdf;base64,${base64}`;

  a.href = linkSource;
  a.download = filename;
  a.click();
};

const getFileFromBase64 = (
  base64: string,
  fileName: string,
  mimeType: string
): File => {
  const arrayBuffer = base64ToArrayBuffer(base64);
  return new File([arrayBuffer], fileName, { type: mimeType });
};

const getMimeTypeFromExtension = (
  extension: 'pdf' | 'jpg' | 'jpeg' | 'png'
): string => {
  const mimeTypes = {
    pdf: 'application/pdf',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
  };

  return mimeTypes[extension];
};

const convertFileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file as Blob);
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(',')[1];
      resolve(base64);
    };

    reader.onerror = error => reject(error);
  });

export default {
  base64ToArrayBuffer,
  openPdfFromBase64,
  downloadPdfFromBase64,
  getFileFromBase64,
  openFile,
  getMimeTypeFromExtension,
  convertFileToBase64,
};
